import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { TTypeOfServiceProvided } from 'types';
import { restaurantClientTypes } from 'appConstants';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { useTranslation } from 'react-i18next';
import style from './ClientTypeSelect.module.scss';

interface IProps {
	setClientType: (value: Nullable<TTypeOfServiceProvided>) => void;
}

export const ClientTypeSelect: React.FC<IProps> = React.memo(({ setClientType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectClientType') }], [t]);
	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return restaurantClientTypes.map((el) => ({
			id: el.clientTypeID,
			name: tForm(el.clientTypeName),
			icon: (
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#${el.clientTypeName}`} />
				</svg>
			),
		}));
	}, [tForm]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="ClientTypeSelect"
			name="clientType"
			label="clientTypeLabel"
			options={mappedOptions}
			onChange={setClientType}
			validationRules={validationRules}
		/>
	);
});
